<template>
  <bankruptcy-file></bankruptcy-file>
</template>

<script>
import BankruptcyFile from '../components/bankruptcy-file/index.vue';

export default { components: { BankruptcyFile } };

</script>
